import { useContext, useEffect, useState } from 'react'
import GlobalContext from '../../../../../../../../context/global-context'
import { OrganizationAPI } from '../../../../../../../../api/organization.api'
import { formatCurrency, formatDate } from '../../../../../../../utils/formatter'
import { cargarCuotasPrestamo } from './prestamoCuotas'
import { esCuotaConciliada } from './prestamoEstado'
import { filtrarCuotasPorYear } from './prestamoPeriodo'
import { esCreditoRecordatorio } from './prestamoRecordatorio'
import clsx from 'clsx'
import iconoEnlace from '../../../../../../../../assets/iconos/iconEnlace.png'
import { Text } from '../../../../../../ui'

const SubTablaPrestamo = ({ row, onConciliar, yearFilter }) => {
  const { currentBusiness } = useContext(GlobalContext)
  const [estado, setEstado] = useState({ loading: true, cuotas: [], error: false })
  const [intento, setIntento] = useState(0)
  const idPrestamo = row.idPrincipal || row.id
  const conciliado = row.status === 'PAGADO' || row.status === 'COBRADO'
  const cuotaBloqueada = cuota => esCreditoRecordatorio({ ...row, cuotaPrestamo: { fecha: cuota.fecha } })
  const soloRecordatorio = estado.cuotas.length > 0
    ? estado.cuotas.every(cuotaBloqueada)
    : esCreditoRecordatorio(row)
  const cuotasVisibles = Number(row.folioCredito) === 6 ? filtrarCuotasPorYear(estado.cuotas, yearFilter) : estado.cuotas

  useEffect(() => {
    let active = true
    setEstado({ loading: true, cuotas: [], error: false })
    new OrganizationAPI().getDataLibroContable(currentBusiness.id, idPrestamo, 'vinculos')
      .then(({ data }) => {
        if (!active) return
        const cuotas = cargarCuotasPrestamo({ ...row, ...data }, true).filter(cuota => cuota.fecha && cuota.capital !== '')
        setEstado({ loading: false, cuotas, error: false })
      })
      .catch(() => {
        if (active) setEstado({ loading: false, cuotas: [], error: true })
      })
    return () => { active = false }
  }, [currentBusiness.id, idPrestamo, intento])

  if (estado.loading) return <p role='status' className='p-4 text-xs'>Cargando cuotas…</p>
  if (estado.error) return <div role='alert' className='p-4 text-xs'>No se pudieron cargar las cuotas. <button type='button' onClick={() => setIntento(value => value + 1)} className='text-accent2 underline'>Reintentar</button></div>
  return (
    <div className='overflow-x-auto p-4'>
      <table className='w-full min-w-[700px] text-xs border-collapse'>
        <caption className='sr-only'>Cuotas del préstamo</caption>
        <thead className='bg-gray-100'><tr>
          {['Fecha', 'Capital', 'Intereses', 'Otros cargos', 'Glosa', 'Total', 'Status', ...(!soloRecordatorio ? ['Acción'] : [])].map(label => <th key={label} scope='col' className='p-2 border'>{label}</th>)}
        </tr></thead>
        <tbody>
          {cuotasVisibles.map((cuota, index) => <tr key={index} className='bg-white'>
            <td className='p-2 border'>{formatDate(cuota.fecha)}</td>
            {['capital', 'interes', 'otrosCargos'].map(campo => <td key={campo} className='p-2 border text-right'>{formatCurrency(cuota[campo])}</td>)}
            <td className='p-2 border'>{cuota.glosa}</td>
            <td className='p-2 border text-right'>{formatCurrency(cuota.total)}</td>
            <td className='p-2 border text-center'>
              <Text className={clsx('inline-flex items-center justify-center rounded-full px-3 py-1 text-[0.6rem] sm:text-[0.65rem] font-semibold uppercase tracking-wider leading-tight',
                esCuotaConciliada(cuota)
                  ? 'text-success bg-success/10'
                  : 'text-danger bg-danger/10'
              )}>
                {esCuotaConciliada(cuota) ? 'Conciliada' : 'Pendiente'}
              </Text>
            </td>
            {!soloRecordatorio && <td className='p-2 border text-center'>
              {!cuotaBloqueada(cuota) && <div className='flex flex-col text-xs text-gray-500 items-center justify-center hover:cursor-pointer'>
                <button type='button' aria-label='Conciliar' disabled={!Number(cuota.representante?.idCuota)} onClick={() => {
                  if (cuotaBloqueada(cuota)) return
                  onConciliar({ ...row, id: idPrestamo, cuotaPrestamo: { ...cuota.representante, fecha: cuota.fecha, total: cuota.total } })
                }}
                  className={clsx('flex text-slate-400 shadow-full-xs rounded-full items-center justify-center w-8 h-8 hover:bg-slate-100/50 transition-colors duration-150', {
                    'bg-accent2 text-white': conciliado,
                    'bg-[#fff]': !conciliado
                  })}>
                  <img src={iconoEnlace} alt='icono enlace' className={clsx('w-5 h-5 transition-all duration-300', { 'brightness-200': conciliado })} />
                </button>
                <Text className='mt-2'>{soloRecordatorio ? 'Solo recordatorio' : conciliado ? 'Conciliado' : 'Conciliar'}</Text>
              </div>}
            </td>}
          </tr>)}
          {!cuotasVisibles.length && <tr><td colSpan={soloRecordatorio ? 7 : 8} className='p-4 text-center'>No hay cuotas disponibles.</td></tr>}
        </tbody>
      </table>
    </div>
  )
}

export default SubTablaPrestamo
